import SubscriptionTable from '@subscriptions/components/tables/subscription-table/subscription-table.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-profile-subscriptions',
  components: {
    'bpc-subscription-table': SubscriptionTable,
  },
})
export default class ProfileSubscriptions extends Vue {
  get contactId() {
    return this.$authorizationService.getContactId();
  }

  filterByContactId() {
    return [{ filterField: 'contact_id', modelField: null, value: this.contactId }];
  }
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
